import React, { Component } from 'react';
import { Modal, Select, Button, Row } from 'antd/lib';
const Option = Select.Option;
import { withApollo } from 'react-apollo';

import Uploader from './Uploader';

class ModalUploader extends Component {
  state = {
    articulosParaSancionar: [],
    cantidadJus: 0,
    montoSancion: 0,
  };

  crearOpciones = ciudad => {
    return (
      <Option key={ciudad._id} value={ciudad._id}>
        {ciudad.nombre}
      </Option>
    );
  };

  handleChange = e => {
    this.setState({
      articulosParaSancionar: e,
    });
  };

  // eslint-disable-next-line no-unused-vars
  handleOk = e => {
    this.props.ocultarModalUploader();
  };

  render() {
    return (
      <div>
        <Modal
          title="Subir un Documento Digital"
          visible={this.props.mostrarModalUploader}
          onCancel={this.props.ocultarModalUploader}
          onOk={this.handleOk}
          width={800}
          style={{ width: 600 }}
          footer={[
            <Button key="back" onClick={this.props.ocultarModalUploader}>
              Volver
            </Button>,
          ]}
        >
          <Row>
            <Uploader
              ocultar={this.props.ocultarModalUploader}
              expediente={this.props.expediente}
            />
          </Row>
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalUploader);
